<template>
  <v-dialog v-model="show" scrollable
            :max-width="$vuetify.breakpoint.width * 0.45">
    <v-card tile :loading="loading">
      <v-card-title class="elevation-2" style="z-index: 2">
        <span class="headline ml-5">{{ $t('updateContact') }}</span>
        <v-spacer/>
        <v-btn @click="closeDialog" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <validation-observer ref="observerUpdate" v-slot="{ passes }">
          <v-form @submit.prevent="passes( update )">
            <v-container fluid>
              <v-row>
                <v-col class="mx-auto" cols="11">
                  <validation-provider :name="$t('newContactForm.first_name.name')" rules="required" v-slot="{ errors }">
                    <v-text-field
                      :error-messages="errors"
                      :label="$t('newContactForm.first_name.label')"
                      v-model="subscriber.first_name"
                      type="text">
                      <template v-slot:prepend-inner>
                        <v-icon small>mdi-form-textbox</v-icon>
                      </template>
                    </v-text-field>
                  </validation-provider>
                </v-col>
                <v-col class="mx-auto" cols="11">
                  <validation-provider :name="$t('newContactForm.last_name.name')" rules="required" v-slot="{ errors }">
                    <v-text-field
                      :error-messages="errors"
                      :label="$t('newContactForm.last_name.label')"
                      v-model="subscriber.last_name"
                      type="text">
                      <template v-slot:prepend-inner>
                        <v-icon small>mdi-form-textbox</v-icon>
                      </template>
                    </v-text-field>
                  </validation-provider>
                </v-col>
                <v-col class="mx-auto" cols="11">
                  <v-text-field
                    :label="$t('newContactForm.title.label')"
                    v-model="subscriber.title"
                    type="text">
                    <template v-slot:prepend-inner>
                      <v-icon small>mdi-medal</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col class="mx-auto" cols="11">
                  <validation-provider :name="$t('newContactForm.approach.name')" rules="required" v-slot="{ errors }">
                    <v-select
                      :error-messages="errors"
                      :items="sex"
                      :label="$t('newContactForm.approach.label')"
                      v-model="subscriber.sex">
                      <template v-slot:prepend-inner>
                        <v-icon small>mdi-google-circles-extended</v-icon>
                      </template>
                    </v-select>
                  </validation-provider>
                </v-col>
                <v-col class="mx-auto" cols="11">
                  <validation-provider :name="$t('newContactForm.email.name')" rules="required|email" v-slot="{ errors }">
                    <v-text-field
                      :error-messages="errors"
                      :label="$t('newContactForm.email.label')"
                      v-model="subscriber.email"
                      type="email">
                      <template v-slot:prepend-inner>
                        <v-icon small>mdi-at</v-icon>
                      </template>
                    </v-text-field>
                  </validation-provider>
                </v-col>
                <v-col class="mx-auto" cols="11">
                  <validation-provider :name="$t('newContactForm.phone.name')" rules="required" v-slot="{ errors }">
                    <v-text-field
                      :error-messages="errors"
                      :label="$t('newContactForm.phone.label')"
                      v-model="subscriber.phone_number"
                      type="text">
                      <template v-slot:prepend-inner>
                        <v-icon small>mdi-phone</v-icon>
                      </template>
                    </v-text-field>
                  </validation-provider>
                </v-col>
                <v-col class="mx-auto" cols="11">
                  <validation-provider :name="$t('newContactForm.salutation.name')" rules="required" v-slot="{ errors }">
                    <v-select
                      :error-messages="errors"
                      :items="salutations"
                      :label="$t('newContactForm.salutation.label')"
                      v-model="subscriber.salutation">
                      <template v-slot:prepend-inner>
                        <v-icon small>mdi-hand-wave</v-icon>
                      </template>
                    </v-select>
                  </validation-provider>
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions class="elevation-2 white pr-6">
              <v-spacer></v-spacer>
              <v-btn color="danger" text @click="closeDialog">{{ $t('newContactForm.buttons.cancel') }}</v-btn>
              <v-btn color="success" text type="submit">{{ $t('newContactForm.buttons.save') }}</v-btn>
            </v-card-actions>
          </v-form>
        </validation-observer>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'UpdateSubscriberDialog',
  data () {
    return {
      loading: false,
      subscriber: {
        first_name: null,
        last_name: null,
        sex: null,
        title: null,
        email: null,
        phone_number: null,
        salutation: null
      },
      sex: [
        'Frau', 'Herr', 'Mrs.', 'Ms', 'Mr.'
      ]
    }
  },
  created () {
    this.unsubscribe = this.$store.subscribeAction((action) => {
      if (action.type === 'setSubscriber' && action.payload !== 0) {
        setTimeout(() => {
          this.getSubscriber()
        }, 150)
      }
    })
  },
  beforeDestroy () {
    this.unsubscribe()
  },
  methods: {
    closeDialog () {
      this.$store.dispatch('setUpdateSubscriberDialog', false)
        .then(() => {
          this.loading = false
          this.$refs.observerUpdate.reset()
          this.$store.dispatch('setSubscriber', 0)
        })
    },
    getSubscriber () {
      this.$http.get(`api/v2/auth/subscriber/${this.$store.getters.GET_SUBSCRIBER}`)
        .then((response) => {
          this.subscriber = response.data.subscriber
          this.$store.dispatch('setUpdateSubscriberDialog', true)
        })
    },
    update () {
      this.loading = true
      this.$http.post(`api/v2/auth/subscriber/${this.$store.getters.GET_SUBSCRIBER}?_method=PATCH`, this.subscriber
      ).then(() => {
        this.closeDialog()
        this.subscriber = this.$worker.reset(this.subscriber)
        this.$root.$emit('reload-subscribers')
      })
    }
  },
  computed: {
    show: {
      get () {
        return this.$store.getters.GET_UPDATE_SUBSCRIBER_DIALOG
      },
      set (value) {
        this.$store.dispatch('setUpdateSubscriberDialog', value)
      }
    },
    salutations () {
      return this.$t('salutation')
    }
  }
}
</script>

<style scoped>

</style>
